import { XEntityPicker } from '@adornis/entity-picker/client/x-entity-picker.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import '@adornis/fonts/fonts.js';
import { customElement } from 'lit/decorators.js';
import { subscribeSearchLocation } from '../api/location.js';
import { Location } from '../db/location.js';

/**
 * @element ils-location-selection
 */
@customElement('ils-location-selection')
export class IlsLocationSelection extends XEntityPicker<typeof Location> {
  constructor() {
    super();
    this.options.next({
      class: Location,
      operation: subscribeSearchLocation,
      filter: new AdornisFilter({
        searchFields: [
          'displayName',
          'address.name',
          'address.streetAndHousenumber',
          'address.zipCity.zip',
          'address.zipCity.city',
          'address.bundesland',
          'address.additionalInfo',
        ],
      }),
      selectionSet: {
        displayName: 1,
        address: {
          name: 1,
          streetAndHousenumber: 1,
          zipCity: { zip: 1, city: 1 },
          bundesland: 1,
          country: 1,
          additionalInfo: 1,
        },
      },
    });
  }
}
